<template>
  <div class="page">
    <div class="nav1">
      当日消费 ({{ day }})
    </div>
    <div class="form" v-if="form">
      <div>
        <span>深夜餐:</span>{{ form.times5_count ||0 }}次
      </div>
      <div>
        <span>早餐:</span>{{ form.times1_count ||0}}次
      </div>
      <div>
        <span>午餐:</span>{{ form.times2_count ||0}}次
      </div>
      <div>
        <span>晚餐:</span>{{ form.times3_count ||0}}次
      </div>
      <div>
        <span>夜宵:</span>{{ form.times4_count ||0}}次
      </div>
    </div>
  </div>
</template>
  
<script>
import { Form } from 'vant'
import dayjs from 'dayjs';
export default {
  data() {
    return {
      isLoading: false,
      form: null,
      day: dayjs().format("YYYY/MM/DD")
    }
  },
  components: {
    'van-form': Form,
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      this.isLoading = true;
      this.axios
        .get('xf/all', { params: { time: [dayjs().format("YYYY/MM/DD"), dayjs().format("YYYY/MM/DD")], current: 1, pageSize: 1 } })
        .then(res => {
          if (res.data.length > 0) {
            this.form = res.data[0]
          } else {
            this.form = {}
          }
        })
        .catch(error => {
          console.log(error)
          this.isLoading = false
          this.$dialog.alert({
            title: '系统异常',
            message: error.message
          })
        })
    },

  }
}
</script>
  
<style scoped lang="less">
.page {
  min-height: 100vh;
  background: #3a88f2;

  .nav1 {
    height: 80px;
    color: #fff;
    line-height: 80px;
    text-indent: 10px;
    font-size: 24px;

    span {
      color: #2765b7;
      font-size: 20px;
    }
  }

  .form {
    background: #f8f8f8;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding-top: 10px;
    box-sizing: border-box;
    height: calc(100vh - 80px);
    width: 100%;

    >div {
      line-height: 50px;

      >span {
        display: inline-block;
        width: 80px;
        text-align: right;
        padding-right: 10px;
      }
    }
  }
}
</style>
  